import React from "react";
import { t } from "i18next";

import { ButtonComp } from "components";

const LinkOptionTile = ({ icon, label, onClick, disabled, classes }) => {
  return <ButtonComp testId={label} className={`${classes}`} label={t(label)} onClick={onClick} icon={icon} disabled={disabled} isLeftIcon={false} />;
};

export default LinkOptionTile;
